import React, { FunctionComponent } from 'react'
import { Button, Heading, Modal, Text } from '@afterpaytouch/core'
import { useCheckoutSizes } from '../../utils/responsive'
import { useTranslation } from 'next-i18next'
import styles from './style.module.css'
import { InstanceProps } from 'react-modal-promise'

interface Props {
  isOpen: boolean
  onResolve?: () => void
  onReject?: () => void
}

export const LeaveCheckoutModal: FunctionComponent<Props & InstanceProps<unknown>> = ({ isOpen, onResolve, onReject }) => {
  const { textSize, headingSize } = useCheckoutSizes()
  const { t } = useTranslation()

  return (
    <Modal show={isOpen} onClose={onReject} showCloseButton>
      <div className={styles.container}>
        <Modal.Header>
          <Heading size={headingSize}>{t('common:leaveCheckoutModal:title')}</Heading>
          <Text size={textSize}>{t('common:leaveCheckoutModal:message', { context: 'consumerLending' })}</Text>
        </Modal.Header>
        <Modal.Content>
          <Button kind='Primary' padding='Fluid' size='Large' testNameSpace='leave-checkout-modal-leave' onClick={onResolve}>
            {t('common:leaveCheckoutModal:cta')}
          </Button>
          <div className={styles.cancelButton}>
            <Button kind='Ghost' padding='Fluid' size='Large' testNameSpace='leave-checkout-modal-cancel' onClick={onReject}>
              {t('common:cancel')}
            </Button>
          </div>
        </Modal.Content>
      </div>
    </Modal>
  )
}
